<span
  *ngIf="view as v"
  class="offline-indicator"
  data-testid="offline-indicator"
  role="status"
  [ngClass]="'offline-indicator--' + v.level"
  [matTooltip]="v.label"
  [attr.aria-label]="v.label">
  <mat-icon>{{ v.icon }}</mat-icon>
  <span class="offline-indicator__pending" *ngIf="state.pending > 0" data-testid="offline-indicator-pending">{{ state.pending }}</span>
</span>
